/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { DeeplinkDto } from '../../models/deeplink-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetDeeplinksByBaumusterAndModelYear$Params {
  /**
   * Market country code
   */
  market: string;

  /**
   * Market language code
   */
  language: string;

  /**
   * Vehicle Baumuster
   */
  baumuster: string;

  /**
   * Vehicle Model Year
   */
  modelYear: string;

  /**
   * Vehicle Change Year
   */
  changeYear?: string;

  /**
   * Vehicle National Sales Type
   */
  nationalSalesType?: string;

  /**
   * Filter product to which Deeplinks should be retrieved (supports multiple values), if not provided, all are included in the response
   */
  productTypes?: Array<'CONFIGURATOR' | 'ONLINE_SHOP' | 'PRODUCT_PAGE' | 'TEST_DRIVE'>;

  /**
   * Dealer Code to be added to Deeplinks of products that support it
   */
  dealerCode?: string;

  /**
   * Configurator Online Code to be used on Deeplinks of products that support it
   */
  onlineCode?: string;

  /**
   * Configuration Code to be used on Deeplinks of products that support it
   */
  configurationCode?: string;

  /**
   * CMS for which to link to. Defaults to PUBLISHER links
   */
  cmsInstance?: 'AUTHOR' | 'PUBLISHER';
}

export function getDeeplinksByBaumusterAndModelYear(
  http: HttpClient,
  rootUrl: string,
  params: GetDeeplinksByBaumusterAndModelYear$Params,
  context?: HttpContext
): Observable<
  StrictHttpResponse<{
    [key: string]: DeeplinkDto;
  }>
> {
  const rb = new RequestBuilder(rootUrl, getDeeplinksByBaumusterAndModelYear.PATH, 'get');
  if (params) {
    rb.path('market', params.market, {});
    rb.path('language', params.language, {});
    rb.path('baumuster', params.baumuster, {});
    rb.path('modelYear', params.modelYear, {});
    rb.query('changeYear', params.changeYear, {});
    rb.query('nationalSalesType', params.nationalSalesType, {});
    rb.query('productTypes', params.productTypes, {});
    rb.query('dealerCode', params.dealerCode, {});
    rb.query('onlineCode', params.onlineCode, {});
    rb.query('configurationCode', params.configurationCode, {});
    rb.query('cmsInstance', params.cmsInstance, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
        [key: string]: DeeplinkDto;
      }>;
    })
  );
}

getDeeplinksByBaumusterAndModelYear.PATH =
  '/deeplinks/{market}/{language}/baumuster/{baumuster}/model-year/{modelYear}';
